import { useState, useEffect } from "react";
import './Reader.css';

function Reader({ album, returnGallery })
{
   const [page, setPage] = useState(0);
   const [imageError, setImageError] = useState(false);
   const pageNumber = String(page).padStart(3, '0');
   const imagePath =`/images/Blacksad/${album.dossier}/page-${pageNumber}.webp`;
     // Get token from localStorage
   const token = localStorage.getItem('token');
   // navigation pages btn click
   const nextPage = () =>
   {
      if (page < album.nbPages - 1)
      {
         setPage(page + 1);
      }
   };
   const previousPage = () =>
   {
      if (page > 0)
      {
         setPage(page - 1);
      }
   };
   useEffect(() =>
   {
      setImageError(false); // Réinitialiser l'état d'erreur lors du changement de page
   }, [page]);

   // navigation pages clavier
   useEffect(() =>
   {
      const handleKeyPress = (event) =>
      {
         if (event.key === 'ArrowRight')
         {
            nextPage();
         } else if (event.key === 'ArrowLeft')
         {
            previousPage();
         }
      };

      window.addEventListener('keydown', handleKeyPress);

      return () =>
      {
         window.removeEventListener('keydown', handleKeyPress);
      };

   }, [page]); // Déclenchement au changement de la variable entre crochets

   return (
      <div className="reader">

         {/* bouton retour galerie */ }
         <button className="back-button" onClick={ returnGallery }>
            ← Retour à la galerie
         </button>

         {/* titre album */ }
         <h2>{ album.titre }</h2>

         {/* navigation */ }
         <div className="navigation">
            <button
               onClick={ previousPage }
               disabled={ page === 0 }>
               ← Précédente
            </button>
            <span>Page { page + 1 } / { album.nbPages }</span>
            <button
               onClick={ nextPage }
               disabled={ page === album.nbPages - 1 }>
               Suivante →
            </button>
         </div>

         {/* image dynamique (page BD) */ }
         <div className='comic-page'>
            { imageError ? 
            ( <div className="error-message">Erreur de chargement de l'image.</div> ) : 
            (
               <img
                  src={ imagePath }
                  alt={ `Page ${page}` }
                  onClick={ nextPage }
                  onError={()=> setImageError(true)}
               />
            )}
         </div>

      </div>
   )
}

export default Reader;